import request from './index'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getSmsCode(mobile) {
  return request({
    url: '/auth/sms-code',
    method: 'post',
    data: { mobile }
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function pwdLogin(query) {
  return request({
    url: `/passport/user/pwdLogin`,
    method: 'post',
    data: query,
    params: query,
  })
}
export function smscodeLogin(query) {
  return request({
    url: `/passport/user/login/smscode`,
    method: 'post',
    data: query,
    params: query,
  })
}

export function mobileLogin(query) {
  return request({
    url: `/passport/user/mobileLogin`,
    method: 'post',
    data: query,
    params: query,
  })
}

export function getCaptchaImage(uuid){
  if (process.env.BASE_URL === '/') {
    return `/mallapi/base/captcha/generate?uuid=${uuid}&scene=LOGIN&r=${new Date().getTime()}`
  }else {
    return `${location.origin}/mallapi/base/captcha/generate?uuid=${uuid}&scene=LOGIN&r=${new Date().getTime()}`
  }
}

// 注册的验证码
export function smscode(query) {
  return request({
    url: `/passport/user/register/smscode`,
    method: 'post',
    data: query,
    params: query,
  })
}


export function register(query) {
  return request({
    url: `/passport/user/register`,
    method: 'post',
    data: query,
    params: query,
  })
}

// 忘记密码的短信
export function findPwdSmscode(query) {
  return request({
    url: `/passport/user/find-pwd/smscode`,
    method: 'post',
    data: query,
    params: query,
  })
}
// 原密码找回密码
export function findPwdByOldPwd(query) {
  return request({
    url: `/passport/user/find-pwd-byOldPwd`,
    method: 'post',
    data: query,
    params: query,
  })
}

// 企业账号原密码找回密码
export function findPwdByOldPwdCompanyName(query) {
  return request({
    url: `/passport/user/find-pwd-byOldPwd-companyName`,
    method: 'post',
    data: query,
    params: query,
  })
}

// 短信找回密码
export function findPwd(query) {
  return request({
    url: `/passport/user/find-pwd`,
    method: 'post',
    data: query,
    params: query,
  })
}

// 修改手机号发送验证码（需登录状态）
export function updateMobileSmscode(query) {
  return request({
    url: `/passport/user/update-mobile/smscode`,
    method: 'post',
    data: query,
    params: query,
  })
}

// 修改手机号（需登录状态）
export function updateMobile(query) {
  return request({
    url: `/passport/user/update-mobile`,
    method: 'post',
    data: query,
    params: query,
  })
}

// 通过企业名称登录
export function pwdLoginByCompanyName(query) {
  return request({
    url: `/passport/user/pwdLoginByCompanyName`,
    method: 'post',
    data: query,
    params: query,
  })
}

// 通过企业名称注册
export function registerByCompanyName(query) {
  return request({
    url: `/passport/user/registerByCompanyName`,
    method: 'post',
    data: query,
    params: query,
  })
}
